import { createApiHook } from '../hooks';
import { recommendationApiFactory } from './recommendationsApiFactory';

export const useRecommendationsApi = createApiHook(recommendationApiFactory);
